import React, { useEffect, useContext, useState, Fragment } from "react";
import {
    Box,
    Button,
    Card,
    CardActions,
    CardMedia,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Paper,
    FormControlLabel,
    FormGroup,
    Grid,
    Input,
    Modal,
    Table,
    TableContainer,
    TextField,
    Typography,
    TableBody,
    TableCell,
    TableRow,
    CardContent,
    TableHead,
    DialogContentText,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import cloneDeep from "lodash/cloneDeep";
import Pagination from "rc-pagination";
import "./pagination.css";
import axios from "axios";
import { consumeGet, URL } from "./utils/constants";
import { AuthContext } from "./context";
import {
    Add,
    AssignmentLate,
    AttachFile,
    Delete,
    Edit,
    History,
    RemoveRedEye,
    SetMealRounded,
} from "@mui/icons-material";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Link } from "react-router-dom";
import { useTheme } from "@emotion/react";
import moment from "moment";
import NotificationsIcon from "@mui/icons-material/Notifications";
export default function BusinessLines() {
    const theme = useTheme();
    const [selected, setSelected] = useState(false);
    const [errors, setErrors] = useState(null);
    const { user } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([])
    const [search, setSearch] = useState("")
    const countPerPage = 10;
    const [add, setAdd] = useState({
        active: 0,
        name: "",
        id_line: "",
        editMode: false
    })
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        if (search.trim() !== "") {
            let result = data.filter((o) => {
                const regex = new RegExp("^" + search, "i");
                return regex.test(o.name) | regex.test(o.id_line);
            });
            const to = countPerPage * currentPage;
            const from = to - countPerPage;
            setCollection(cloneDeep(result.slice(from, to)))
        } else {
            const to = countPerPage * currentPage;
            const from = to - countPerPage;
            setFilteredData([...data]);
            setCollection(cloneDeep(data.slice(from, to)))
        }
    }, [search, data]);
    const getData = async () => {

        try {
            const result = await axios.get(
                `${URL}business_lines`,
                {
                    headers: {
                        Authorization: "Bearer " + user.token,
                        "Access-Control-Allow-Origin": "*",
                    },
                }
            );
            if (result.status === 200) {
                setData([...result.data]);
            } else {
                console.log(result.data)
            }
        } catch (err) {
            console.log(err)
        }
    }
    useEffect(() => {
        getData()
    }, []);
    const [collection, setCollection] = useState(
        cloneDeep(filteredData.slice(0, countPerPage))
    );
    const updatePage = (p) => {
        setCurrentPage(p);
        const to = countPerPage * p;
        const from = to - countPerPage;
        setCollection(cloneDeep(filteredData.slice(from, to)));
    };
    const [modal, setModal] = useState({
        open: false,
        toConfirm: null,
        description: "",
    });
    const [deleteModal, handleDeleteModal] = useState(null);
    const handleConfirm = async (type, time) => {
        // const userId = await OneSignal.getUserId();
        const params = {
            active: add.active,
            name: add.name,
            id_line: add.id_line,
        };
        let result;
        if (add.editMode) {
            result = await axios
                .put(`${URL}business_lines/${add.id_line}`, params, {
                    headers: {
                        Authorization: "Bearer " + user.token,
                        "Access-Control-Allow-Origin": "*",
                    },
                })
                .catch((err) =>
                    setErrors(err.response.data.errors)
                );
        }
        else {
            result = await axios
                .post(`${URL}business_lines`, params, {
                    headers: {
                        Authorization: "Bearer " + user.token,
                        "Access-Control-Allow-Origin": "*",
                    },
                })
                .catch((err) =>
                    setErrors(err.response.data.errors)
                );
        }
        try {
            if (result.status === 200) {
                setSelected(false);
                setAdd({
                    active: 0,
                    name: "",
                    id_line: "",
                    editMode: false
                });
                getData();
            } else {
                setErrors(result.data.errors);
            }
        } catch (err) {
            console.log(err.response);
        }
    };
    const handleConfirmPick = async (id, orderId) => {
        try {
            setModal({
                description: `Order No. ${orderId} will go to "To Pick up"`,
                open: true,
                toConfirm: id,
            });
        } catch (err) {
            console.log(err);
        }
    };
    const handleErase = async () => {
        const config = {
            headers: {
                Authorization: "Bearer " + user.token,
            },
        };

        const result = await axios.delete(
            `${URL}business_lines/${deleteModal}`,
            config
        ).catch((err) => {
            handleDeleteModal(null)
            setErrors(err.response.data.errors)
        }
        );

        if (result.status === 200) {
            handleDeleteModal(null);
            getData();


        } else {
            handleDeleteModal(null)

            setErrors(result.data.errors)
        }
    };
    return (
        <Box style={{ padding: 20 }}>
            {selected && (
                <Dialog fullWidth maxWidth="md" open={true}>
                    <DialogTitle style={{ textAlign: "center" }}>{add.editMode ? "Editar" : "Agregar"} Linea de Negocio</DialogTitle>
                    <DialogContent>
                        <Box
                            width="90%"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            flexDirection="column"
                        >
                            <FormControl sx={{ m: 1, width: "100%", justifyContent: "start" }}>
                                <FormControlLabel
                                    control={
                                        <div style={{ width: "91%" }}>

                                            <TextField
                                                style={{
                                                    marginLeft: 24,
                                                    boxShadow: "rgb(116 116 116) 1px 0px 1px",
                                                    borderRadius: 4,
                                                }}
                                                fullWidth
                                                inputProps={{ style: { borderRadius: 18 } }}
                                                value={add.id_line}
                                                disabled={add.editMode}
                                                onChange={(e) =>
                                                    setAdd({
                                                        ...add,
                                                        id_line: e.target.value,
                                                    })
                                                }
                                            />
                                        </div>
                                    }
                                    label="Id Line"
                                    style={{ justifyContent: "start" }}
                                    labelPlacement="start"
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: "100%" }}>
                                <FormControlLabel
                                    control={
                                        <TextField
                                            style={{
                                                marginLeft: 24,
                                                boxShadow: "rgb(116 116 116) 1px 0px 1px",
                                                borderRadius: 4,
                                            }}
                                            inputProps={{ style: { borderRadius: 18 } }}
                                            value={add.name}
                                            fullWidth
                                            onChange={(e) =>
                                                setAdd({
                                                    ...add,
                                                    name: e.target.value,
                                                })
                                            }
                                        />
                                    }
                                    label="Name"
                                    labelPlacement="start"
                                />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: "100%" }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: 8, }}>

                                    <Typography style={{ marginRight: 18, marginLeft: 8 }}>Estado</Typography>
                                    <Select
                                        labelId="select"
                                        id="demo-simple-select-helper"
                                        value={add.active}
                                        fullWidth
                                        label="Option List Group"
                                        onChange={(e) => {
                                            setAdd({
                                                ...add,
                                                active: e.target.value,
                                            });
                                        }}
                                    >
                                        <MenuItem
                                            selected={add.active === 1 ? true : false}
                                            value={1}
                                        >
                                            Activo
                                        </MenuItem>
                                        <MenuItem
                                            selected={!add.active === 1 ? true : false}
                                            value={0}
                                        >
                                            Inactivo
                                        </MenuItem>
                                    </Select>
                                </div>
                            </FormControl>
                        </Box>
                        {errors && (
                            <Card style={{ width: "80%", marginLeft: "10%" }}>
                                <CardContent>
                                    {Object.values(errors).map((e) => (
                                        <Typography color="#df4759" textAlign="center">
                                            *{e}
                                        </Typography>
                                    ))}
                                </CardContent>
                            </Card>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            color="inherit"
                            onClick={() => {
                                setSelected(false)
                                setAdd({
                                    active: 0,
                                    name: "",
                                    id_line: "",
                                    editMode: false
                                })
                            }
                            }
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <Button onClick={() => handleConfirm()} variant="contained">
                            {add.editMode ? "Editar" : "Añadir"}
                        </Button>
                    </DialogActions>
                </Dialog>
            )}{
                deleteModal && (
                    <Dialog open={true}>
                        <Box style={{ padding: 12 }}>
                            <DialogTitle
                                style={{
                                    marginBottom: 20,
                                    textAlign: "center",
                                    fontSize: 20,
                                    fontWeight: 800,
                                }}
                            >
                                Eliminar
                            </DialogTitle>
                            <DialogContent>
                                <Typography style={{ marginBottom: 12 }}>
                                    ¿Estas seguro de eliminar esta linea de negocio?
                                </Typography>
                            </DialogContent>
                            <DialogActions>
                                <Fragment>
                                    <Button
                                        color="inherit"
                                        onClick={() =>
                                            handleDeleteModal(null)
                                        }
                                        variant="contained"
                                        style={{ width: "50%" }}
                                    >
                                        Cancelar
                                    </Button>
                                    <Button
                                        style={{ width: "50%" }}
                                        onClick={() => handleErase()}
                                        variant="contained"
                                    >
                                        Eliminar
                                    </Button>
                                </Fragment>
                            </DialogActions>
                        </Box>
                    </Dialog>
                )
            }

            <Dialog open={modal.open}>
                <Box style={{ padding: 12 }}>
                    <DialogTitle
                        style={{
                            marginBottom: 20,
                            textAlign: "center",
                            fontSize: 20,
                            fontWeight: 800,
                        }}
                    >
                        ¡Great!
                    </DialogTitle>
                    <DialogContent>
                        <Typography style={{ marginBottom: 12 }}>
                            {modal.description}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        {modal.toConfirm ? (
                            <Fragment>
                                <Button
                                    color="inherit"
                                    onClick={() =>
                                        setModal({ open: false, toConfirm: null, description: "" })
                                    }
                                    variant="contained"
                                    style={{ width: "50%" }}
                                >
                                    Cancel
                                </Button>
                                <Button
                                    style={{ width: "50%" }}
                                    onClick={() => handleErase()}
                                    variant="contained"
                                >
                                    Ok
                                </Button>
                            </Fragment>
                        ) : (
                            <Box display="flex" justifyContent="center" alignItems="center">
                                <Button
                                    style={{ width: "50%" }}
                                    onClick={() =>
                                        setModal({ open: false, toConfirm: null, description: "" })
                                    }
                                    variant="contained"
                                >
                                    Ok
                                </Button>
                            </Box>
                        )}
                    </DialogActions>
                </Box>
            </Dialog>
            {errors && (
                <Dialog
                    open={true}
                    onClose={() => setErrors(null)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {Array.isArray(errors) ? errors.map((e) => (
                                <Typography>{e.param}: {e.msg}</Typography>
                            )) : Object.values(errors).map((v) => (
                                <Typography>* {v}</Typography>
                            ))}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setErrors(null)}>
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
            <Box>
                <Grid container>
                    <Grid xs={12} style={{ marginBottom: 14 }}>
                        <Typography style={{ fontSize: 21, color: theme.palette.primary.main, textAlign: "center", fontWeight: 800 }}>
                            Lineas de negocios
                        </Typography>

                    </Grid>
                </Grid>
                <Grid container>
                    <Grid xs={6} style={{ marginBottom: 14, justifyContent: "center", alignItems: "center", display: "flex" }}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                setSelected(true)
                                setAdd({
                                    active: 0,
                                    name: "",
                                    id_line: "",
                                    editMode: false
                                })
                            }}
                        >
                            Crear +
                        </Button>
                    </Grid>
                    <Grid xs={6} style={{ marginBottom: 14, justifyContent: "center", alignItems: "center", display: "flex" }}>
                        <Box>
                            <TextField placeholder="Buscar" value={search} onChange={(e) => setSearch(e.target.value)} />
                        </Box>
                    </Grid>
                </Grid>
                {collection.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableCell>
                                    <Typography fontWeight={800}>Id</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight={800}>Nombre LN</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight={800}>Fecha de Inicio</Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography fontWeight={800}>Hora inicio</Typography>
                                </TableCell>
                                <TableCell>                                    <Typography align="center" fontWeight={800}>Status</Typography></TableCell>
                                <TableCell></TableCell>
                            </TableHead>
                            <TableBody>
                                {collection.map((o) => (
                                    <TableRow hover>
                                        <TableCell>{o.id_line}</TableCell>
                                        <TableCell>
                                            {o.name}
                                        </TableCell>
                                        <TableCell>{o.dat.split("T")[0]}</TableCell>
                                        <TableCell>{o.hou}</TableCell>
                                        <TableCell style={{ display: "flex", justifyContent: "center", alignItems: "center" }}><Typography>
                                            {
                                                o.statu ? "Activo" : "Inactivo"
                                            }
                                        </Typography>
                                            <div style={{ width: 12, height: 12, backgroundColor: o.statu ? "lightgreen" : "red", marginLeft: 5, borderRadius: 50 }}></div>
                                        </TableCell>
                                        <TableCell>
                                            <div style={{ display: "flex" }}>
                                                <Button onClick={() => {
                                                    setSelected(true)
                                                    setAdd({
                                                        active: o.statu,
                                                        name: o.name,
                                                        id_line: o.id_line,
                                                        editMode: true
                                                    })
                                                }}>

                                                    <Edit />
                                                </Button>
                                                <Button onClick={() => handleDeleteModal(o.id_line)}>

                                                    <Delete />
                                                </Button>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                ) : (
                    <Box
                        width="100%"
                        height={400}
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <AssignmentLate style={{ fontSize: 92 }} />
                        <Typography>No se ha creado ninguna linea de negocios</Typography>
                    </Box>
                )}
                <Box
                    marginTop={3}
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                >
                    <Pagination
                        pageSize={countPerPage}
                        onChange={updatePage}
                        current={currentPage}
                        total={data.length}
                    />
                </Box>
            </Box>
        </Box>
    );
}
